import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    text: 'Por fin encontré una guía simple y clara. El semáforo de ingredientes lo imprimí y lo pegué en mi cocina. Ahora sé exactamente qué puedo darle y qué no antes de cocinar.',
    author: 'María G.',
    pet: 'dueña de un labrador de 3 años'
  }, {
    text: 'El planificador me ayudó a organizarme desde la primera semana. Antes improvisaba todo el tiempo y no sabía si lo que le daba era seguro. Ahora me siento mucho más tranquila.',
    author: 'Sofía R.',
    pet: 'dueña de un golden retriever'
  }, {
    text: 'El Kit SOS fue lo que más me sorprendió. No pensé que iba a necesitarlo, pero un día mi perro comió algo del suelo y gracias a la ficha de emergencia pude llamar al veterinario con toda la información lista.',
    author: 'Carlos M.',
    pet: 'dueño de un beagle'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-182">
      <div className="max-w-6xl mx-auto" data-id="element-183">
        <div className="text-center mb-16" data-id="element-184">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-185">
            Lo que otros dueños de perros dicen:
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-186"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-187">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-cream p-8 rounded-3xl relative" data-id="element-188">
              <div className="flex gap-1 mb-6" data-id="element-189">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-190" />)}
              </div>
              <p className="text-gray-700 italic mb-8 relative z-10" data-id="element-191">
                "{testimonial.text}"
              </p>
              <div data-id="element-192">
                <p className="font-bold text-brand-navy" data-id="element-193">
                  {testimonial.author}
                </p>
                <p className="text-sm text-gray-500" data-id="element-194">{testimonial.pet}</p>
              </div>
              {/* Quote mark decoration */}
              <div className="absolute top-4 right-6 text-6xl text-brand-beige font-serif opacity-50 select-none" data-id="element-195">
                "
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}